export function algorithFieldListObj(notHeldDestination:any, notHeldAlgorithm:any) {

  const algorithFieldListObj = [{
    destination: "CITADEL",
    algorithm: "VWAP",
    listofFields: ["ordNotHeldFillPolicy", "ordNotHeldStartTime", "ordNotHeldEndTime"]
  }, {
    destination: "CITADEL",
    algorithm: "TWAP",
    listofFields: ["ordNotHeldFillPolicy", "ordNotHeldStartTime", "ordNotHeldEndTime"]
  }, {
    destination: "CITADEL",
    algorithm: "PERCENTAGE_OF_VOLUME",
    listofFields: ["ordNotHeldFillPolicy", "ordNotHeldStartTime", "ordNotHeldEndTime", "ordNotHeldPartRate", "ordNotHeldInclude"]
  }, {
    destination: "VIRTU",
    algorithm: "VWAP",
    listofFields: ["ordNotHeldStartTime", "ordNotHeldEndTime", "ordNotHeldMaxVolPct"]
  }, {
    destination: "VIRTU",
    algorithm: "TWAP",
    listofFields: ["ordNotHeldStartTime", "ordNotHeldEndTime", "ordNotHeldMaxVolPct"]
  }, {
    destination: "VIRTU",
    algorithm: "PERCENTAGE_OF_VOLUME",
    listofFields: ["ordNotHeldStartTime", "ordNotHeldEndTime", "ordNotHeldMaxVolPct"]
  }, {
    destination: "VIRTU",
    algorithm: "TARGET_CLOSE",
    listofFields: ["ordNotHeldStartTime", "ordNotHeldAuctionOnly", "ordNotHeldStyle"]
  }, {
    destination: "VIRTU",
    algorithm: "FAN",
    listofFields: ["ordNotHeldMaxDispSize", "ordNotHeldStyle"]
  }, {
    destination: "VIRTU",
    algorithm: "OASIS",
    listofFields: ["ordNotHeldStartTime", "ordNotHeldEndTime", "ordNotHeldStyle"]
  }, {
    destination: "VIRTU",
    algorithm: "OPPORTUNISTIC",
    listofFields: ["ordNotHeldStartTime", "ordNotHeldEndTime", "ordNotHeldMaxVolPct", "ordNotHeldStyle"]
  }, {
    destination: "VIRTU",
    algorithm: "COVERT",
    listofFields: ["ordNotHeldStyle"]
  }, {
    destination: "VIRTU",
    algorithm: "CATCH",
    listofFields: ["ordNotHeldStartTime", "ordNotHeldEndTime", "ordNotHeldMaxVolPct", "ordNotHeldStyle"]
  }
  ];

  return algorithFieldListObj.filter((entry:any)=> ((entry.destination == notHeldDestination) && (entry.algorithm == notHeldAlgorithm)));
}
